module.exports = __webpack_public_path__ + "img/credit-retail.b9f83ba1.png";